export type Interpretation = 'auto' | 'shaped' | 'shapeless';

export interface GameSettings {
  sound: boolean;
  mockAi: boolean;
  model: string;
  strictness: number; // 0..2
  interpretation: Interpretation;
  devMode: boolean;
  rerollCooldownMs: number;
}

export const DEFAULT_SETTINGS: GameSettings = {
  sound: true,
  mockAi: false,
  model: 'openai/gpt-4o-mini',
  strictness: 1,
  interpretation: 'auto',
  devMode: false,
  rerollCooldownMs: 15000,
};

export const RARITY_COLORS: Record<string, string> = {
  common: '#ffffff',
  uncommon: '#7cff7c',
  rare: '#6aa6ff',
  epic: '#c676ff',
  legendary: '#ffb347',
};

export const TIER_LABELS = ['Tier 0', 'Tier 1', 'Tier 2', 'Tier 3', 'Tier 4', 'Tier 5'];
